// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { noteSchema } from '@/ticket/api/types';
import { z } from 'zod';

export const getTicketNotesRequestSchema = z.object({
  key: z.string(),
});

type GetTicketNotesRequest = z.infer<typeof getTicketNotesRequestSchema>;

const dataSchema = z.array(noteSchema);

const getTicketNotesResponseSchema = z.object({
  data: dataSchema,
});

type GetTicketNotesResponse = z.infer<typeof dataSchema>;

/**
 * Get notes for a ticket
 */
export async function getTicketNotes(
  request: GetTicketNotesRequest
): Promise<GetTicketNotesResponse> {
  const url = `/v1/ticket/${request.key}/note`;
  const response = await api.get(url);
  const parsed = await parseResponse(
    getTicketNotesResponseSchema,
    response.data,
    {
      schemaName: 'TicketNotes',
      endpoint: url,
    }
  );
  return parsed.data;
}
